import { Fragment } from "react";
import { Card, Col, CardBody, Badge } from "reactstrap";
import { Rating } from "react-simple-star-rating";
import { JOB_DATA } from "../../../../Data/JobSearch";
import { H4, Image, P, Ribbon } from "../../../../AbstractElements";
import { Href } from "../../../../Constant";
import { Link } from "react-router-dom";
import { dynamicImage } from "../../../../Service/DynamicImage";

const CardsClass = () => {
  return (
    <Fragment>
      {JOB_DATA &&
        JOB_DATA.map((item) => (
          <Col xl="6" className="xl-100" key={item.id}>
            <Card className={`${item.ribbion ? "ribbon-vertical-left-wrapper" : ""}`}>
              {item.ribbion ? (
                <Ribbon className={`ribbon ribbon-bookmark ribbon-vertical-left ribbon-secondary ${!item.ribbion && "d-none"}`}>
                  <i className="icofont icofont-love"></i>
                </Ribbon>
              ) : ("  ")}
              <div className="job-search">
                <CardBody>
                  <div className="d-flex">
                    <Image  width="40" height="40" className="img-40 b-r-0 img-fluid m-r-20" src={dynamicImage(`${item.logo}`)} alt="job"/>
                    <div className="flex-grow-1">
                      <H4 className="f-w-700">
                        <Link to={Href}>{item.job_name}</Link>
                        {item.type === "new" ? (<Badge color="primary" className="pull-right">{item.badgeValue}</Badge>) : (<span className="pull-right">{item.type}</span>)}
                      </H4>
                      <P>
                        {item.job_area}, {item.job_city}
                        <Rating className="rating ms-1" fillColor="#feb858 " initialValue={Math.random() * 5} size={14}/>
                      </P>
                    </div>
                  </div>
                  <P>{item.Job_description}</P>
                </CardBody>
              </div>
            </Card>
          </Col>
        ))}
    </Fragment>
  );
};
export default CardsClass;
